export const ApiErrorCodes = {
    NoMatterPermission: "NoMatterPermission",
}